import * as React from 'react';

import { usePhoneValue, IUsePhoneValueParams } from './utils/usePhoneValue';
import { PhoneFieldView, IPhoneFieldViewProps } from './components/PhoneFieldView';

export type IPhoneFieldProps = IUsePhoneValueParams &
  Pick<IPhoneFieldViewProps, 'error' | 'placeholder' | 'autoFocus' | 'onBlur'>;

/**
 * Переиспользуемый компонент - поле ввода номера телефона
 * Телефон вводится по маске: +7 (123) 456-78-90
 * Хранит значение у себя в стейте, умеет валидировать корректность ввода телефона
 * Имеет пропс onChange - для доступа к стейту извне
 * */
export const PhoneField: React.FC<IPhoneFieldProps> = props => {
  const { error, placeholder, autoFocus, onBlur } = props;
  const { value, onChange } = usePhoneValue(props);

  return (
    <PhoneFieldView
      error={error}
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      autoFocus={autoFocus}
      onBlur={onBlur}
    />
  );
};

PhoneField.displayName = 'PhoneField';
